

















import { Vue, Component } from 'vue-property-decorator';
import CommonDialog from '../organisms/CommonDialog.vue';
import { LessonMessageService } from '../../biz/remote/LessonMessageService';
import { Session } from '../../utils/Session';
import { MessageDialog } from '../../utils/MessageDialog';

@Component({ components: { CommonDialog } })
export default class EmergencyMessageDialog extends Vue {
  private class_id = 0;
  private message = '';

  async send() {
    const ok = await MessageDialog.confirm('メッセージを送信します。この操作は取り消しできません。よろしいですか？');
    if (ok) {
      const biz = new LessonMessageService();
      const response = await biz.send(this.class_id, Session.getSessionUserId(), this.message, Session.getSessionBuildingId());
      this.$emit('send', response.data);
      await MessageDialog.alert('メッセージの送信を完了しました。');
      this.close();
    }
  }

  public async show(class_id: number) {
    this.class_id = class_id;
    (this.$refs['emergency_message_dialog'] as CommonDialog).show();
  }

  public close() {
    this.message = '';
    (this.$refs['emergency_message_dialog'] as CommonDialog).hide();
  }
}
